import {peekAnalyticsClientId} from "analytics/analyticsClientId";
import {sendAnalyticsEvent} from "analytics/analyticsEventClient";
import {getConsent} from "consent/consentStore";
import {momentArm, type MomentArm} from "./upgradeMomentArm";
import {momentEligibleParams} from "./upgradeMomentReport";
import type {UpgradeMomentId} from "./upgradeMoments";

/**
 * The browser half of the upgrade moments' tests (kitecorp/transferify-ui#2909): where each moment's
 * half comes from, and the one event that reports eligibility. React-free and lazy, like
 * `games/gameAdapters`: nothing is read until a moment is decided.
 */

/** Each moment's half, drawn once per page load, so a visitor never switches halves mid-visit. */
const drawn = new Map<UpgradeMomentId, MomentArm>();

export function upgradeMomentArm(moment: UpgradeMomentId): MomentArm {
	let arm = drawn.get(moment);
	if (arm === undefined) {
		// The client id counts only while analytics is granted: without consent there is no id, no event
		// leaves the browser, and the visitor gets a fair draw that is stored nowhere.
		const clientId = getConsent().analytics ? peekAnalyticsClientId() : null;
		arm = momentArm(moment, clientId, Math.random);
		drawn.set(moment, arm);
	}
	return arm;
}

/** The test's denominator, through the consent-gated first-party path. */
export function reportMomentEligible(moment: UpgradeMomentId, arm: MomentArm): void {
	sendAnalyticsEvent("UPGRADE_MOMENT_ELIGIBLE", momentEligibleParams(moment, arm));
}
